import React from 'react';

export default ({item, calculatePositionOfStickyHeaders, config, index}) => (
  <td
    className={`text-${config.direction || 'center'} ${
      index === 0 ? 'first-cell' : ''
    } align-middle`}
    style={{
      ...calculatePositionOfStickyHeaders(config),
      paddingRight: 26,
      paddingLeft: 26,
    }}
  >
    {item[config.prop]}
  </td>
);
